import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {PRIVACY_POLICY_URL} from '../../constants/app.constants';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  registerForm: UntypedFormGroup;
  submitted = false;
  errorMessage: string;
  displayAlert = false;
  privacyPolicyUrl = PRIVACY_POLICY_URL;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private httpClient: HttpClient,
    public authenticationService: AuthenticationService,
    public utilsService: UtilsService,
  ) {
  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  get controls() {
    return this.registerForm.controls;
  }

  onSubmitForgotPassword() {
    this.submitted = true;
    if (!this.registerForm.valid) {
      this.utilsService.displayMessage('Error on form',
        'Please check the form values and resubmit', 'warn');
      return;
    }
    const input = {};
    input['email'] = this.registerForm.value.email;
    this.httpClient.post(environment.baseUrlWs + '/request-reset-password', input).subscribe();
    this.displayAlert = true;
  }

  showErrorMessage(fieldName: string): boolean {
    if (!this.registerForm.controls[fieldName]) {
      return false;
    }
    return !this.registerForm.controls[fieldName].valid;
  }
}
